import './modalInformation.css';
import ButtonTemplate from '../buttonTemplate/ButtonTemplate';
import ReactFocusLock from 'react-focus-lock';
import { useStoreContext } from '../../hooks/context/StoreContext';
import { ReactComponent as IconeSucesso } from '../../assets/icones/checkcircle.svg';
import { ReactComponent as IconeAtencao } from '../../assets/icones/warning.svg';

const ModalInformation = ({
    isOpen,
    closeModal,
    icone,
    titulo,
    texto
}) => {

    const { setModal } = useStoreContext();

    const handleFecharModal = (e) => {
        if (e.key === 'Escape') {
            setModal(prevModal => ({
                ...prevModal,
                openModalInformacao: false
            }));
        };
    };


    if (isOpen) {
        return (
            <div className='container information' onKeyDown={handleFecharModal}>
                <ReactFocusLock>
                    <div className='modal information'>
                        <div className='modal-header information'>
                            {icone === 'warning' ?
                                <IconeAtencao />
                                :
                                <IconeSucesso />
                            }
                        </div>
                        <div className='modal-body'>
                            <div className='container-information'>
                                <h4>{titulo}</h4>
                                <p dangerouslySetInnerHTML={{ __html: texto }} />
                            </div>
                        </div>
                        <div className='modal-footer information'>
                            <ButtonTemplate click={closeModal}>
                                Fechar
                            </ButtonTemplate>
                        </div>
                    </div>
                </ReactFocusLock>
            </div>
        );
    };
};

export default ModalInformation;